import { render, staticRenderFns } from "./BoothTypeQuickPropsEditor.vue?vue&type=template&id=e56fadf6"
import script from "./BoothTypeQuickPropsEditor.vue?vue&type=script&lang=ts"
export * from "./BoothTypeQuickPropsEditor.vue?vue&type=script&lang=ts"
import style0 from "./BoothTypeQuickPropsEditor.vue?vue&type=style&index=0&id=e56fadf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports